// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ax5bo","title":"styles_title__dPinp","subtitle":"styles_subtitle__okKAg","img":"styles_img__fUt0N"};